import morphdom from "morphdom";

/**
 * morph
 *
 * A minimal wrapper around morphdom that provides some
 * additional control over morphing, to help preserve state
 * and ensure inline scripts are executed
 *
 * data-force-update
 *   Replaces entire element
 *
 * data-attributes-only="attribute1,attribute2"
 *   Updates only specified attributes and ignores any children
 * @param {*} from Element to morph
 * @param {*} to Element to morph to
 */
export default function morph(from, to) {
  morphdom(from, to, {
    onNodeAdded: (node) => {
      if (node.nodeName === "SCRIPT") {
        var script = document.createElement("script");
        [...node.attributes].forEach((attr) => {
          script.setAttribute(attr.nodeName, attr.nodeValue);
        });

        script.innerHTML = node.innerHTML;
        node.replaceWith(script);
      }
    },
    onBeforeElUpdated: (fromEl, toEl) => {
      if (fromEl.nodeName === "SCRIPT" && toEl.nodeName === "SCRIPT") {
        var script = document.createElement("script");
        [...toEl.attributes].forEach((attr) => {
          script.setAttribute(attr.nodeName, attr.nodeValue);
        });

        script.innerHTML = toEl.innerHTML;
        fromEl.replaceWith(script);
        return false;
      }

      if (fromEl.nodeName === "IMG" && toEl.nodeName === "IMG") {
        if (fromEl.srcset !== toEl.srcset) {
          fromEl.replaceWith(toEl);
          return false;
        }
      }

      if ("forceUpdate" in fromEl.dataset || "forceUpdate" in toEl.dataset) {
        fromEl.replaceWith(toEl);
        return false;
      }

      if ("attributesOnly" in fromEl.dataset) {
        fromEl.dataset.attributesOnly.split(",").forEach((attribute) => {
          // skip blanks
          if (!attribute) return;

          fromEl.setAttribute(attribute, toEl.getAttribute(attribute));
        });

        return false;
      }
    },
  });
}
